module.exports = __webpack_public_path__ + "fonts/PretendardVariable.4097c3a.woff2";